module.exports = __webpack_public_path__ + "static/media/material_10y_n-1.a43c00b8.csv";